export const AvoraMark = ({ className = "h-8 w-8", dark = false }) => (
  <svg viewBox="0 0 40 40" className={className} fill="none" aria-hidden="true">
    <rect x="2.5" y="13" width="23" height="23" stroke="#D4AF5A" strokeWidth="3.4" />
    <rect x="13" y="3" width="23" height="23" stroke={dark ? "#FFFFFF" : "#0D2B45"} strokeWidth="3.4" />
  </svg>
);

export const AvoraLogo = ({ dark = false, size = "md", sub }) => {
  const big = size === "lg";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <AvoraMark dark={dark} className={`shrink-0 ${big ? "h-11 w-11" : size === "sm" ? "h-6 w-6" : "h-9 w-9"}`} />
      <div>
        <div className={`leading-none whitespace-nowrap ${big ? "text-[28px]" : size === "sm" ? "text-base" : "text-[21px]"}`}>
          <span className={`font-logo font-bold tracking-[-0.01em] ${dark ? "text-white" : "text-[#0D2B45]"}`}>AVORA</span>
          <span className="font-logo italic ml-0.5 text-[#D4AF5A]">logic</span>
          <sup className="text-[0.32em] ml-0.5 text-[#D4AF5A] align-super">®</sup>
        </div>
        {sub && <div className={`${big ? "text-[10.5px] tracking-[0.24em]" : size === "sm" ? "text-[8px] tracking-[0.12em]" : "text-[7.5px] tracking-[0.1em]"} uppercase whitespace-nowrap mt-1.5 font-medium ${dark ? "text-[#F6F4EE]" : "text-slate-500"}`}>{sub}</div>}
      </div>
    </div>
  );
};
